import auth from "@/services/CRMinitAuth"

const list = () => {
  return auth.get(`${process.env.VUE_APP_CRM_API}payments/payment_labels/`)
}

const create = data => {
  return auth.post(`${process.env.VUE_APP_CRM_API}payments/`, data)
}

const cancel = ID => {
  return auth.post(`${process.env.VUE_APP_CRM_API}payments/${ID}/cancel/`)
}

export default {
  list,
  create,
  cancel
}